import { format } from "date-fns";
import { DateTime } from "luxon";

// export const formatDate = (dateString) => {
//   return new Date(dateString).toLocaleString("en-GB", {
//     weekday: "long", // Day of the week (e.g., "Sunday")
//     day: "numeric", // Day of the month (e.g., "17")
//     month: "long", // Month name (e.g., "March")
//     year: "numeric", // Year (e.g., "2025")
//     hour: "2-digit", // Hour (e.g., "14")
//     minute: "2-digit", // Minutes (e.g., "30")
//     second: "2-digit", // Seconds (e.g., "45")
//     hour12: true, // Use 24-hour format
//   });
// };

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString("en-US", {
    month: "short",   // Feb
    day: "2-digit",   // 08
    year: "numeric",  // 2026
    hour: "2-digit",  // 02
    minute: "2-digit",// 00
    hour12: true      // PM format
  });
};

export const toDecimal = (amount) => {
  return amount != null && amount !== "" ? parseFloat(amount).toFixed(2) : "0.00";
};

export const toCurrency = (amount) => {
  return `$${amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
};

export const toDate = (dateString) => {
  return format(new Date(dateString), "MM-dd-yyyy");
};

export const phoneNumber = (number) => {
  return number.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
};

export const convertToUTCDate = (date) => {
  const inputDate = new Date(date);
  const y = inputDate.getFullYear();
  const m = inputDate.getMonth(); // 0-indexed
  const d = inputDate.getDate();

  // Create a UTC midnight for that calendar date:
  const utcMidnightIso = new Date(Date.UTC(y, m, d)).toISOString();
  return utcMidnightIso;
};

export const formatDateISO = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
    const dd = String(d.getUTCDate()).padStart(2, "0");
    const yyyy = d.getUTCFullYear();
    return `${mm}/${dd}/${yyyy}`;
  } catch (e) {
    return iso;
  }
};

export const pstDateToUtc = (dateStr) => {
  return DateTime
    .fromISO(dateStr, { zone: "America/Los_Angeles" }) // PST/PDT midnight
    .startOf("day")
    .toUTC()
    .toISO();
}


export const utcToPstDate = (utcDate) => {
  return DateTime
    .fromJSDate(new Date(utcDate), { zone: "utc" })
    .setZone("America/Los_Angeles")
    .toFormat("MM-dd-yyyy"); // date only for UI
}

// Convert a UTC date to a display string in the given timezone abbreviation (PT, MT, CT, ET, AKT, HST, UTC)
export const utcToDateByTz = (utcDate, tz) => {
  const ianaZone = TZ_IANA_MAP[tz] ?? "UTC";
  return DateTime
    .fromJSDate(new Date(utcDate), { zone: "utc" })
    .setZone(ianaZone)
    .toFormat("MM-dd-yyyy");
};

// Convert a date string to UTC based on a timezone abbreviation (PT, MT, CT, ET, AKT, HST, UTC)
const TZ_IANA_MAP = {
  UTC: "UTC",
  PT:  "America/Los_Angeles",
  MT:  "America/Denver",
  CT:  "America/Chicago",
  ET:  "America/New_York",
  AKT: "America/Anchorage",
  HST: "Pacific/Honolulu",
};

export const dateToUtcByTz = (dateStr, tz) => {
  const ianaZone = TZ_IANA_MAP[tz] ?? "UTC";
  return DateTime
    .fromISO(dateStr, { zone: ianaZone })
    .startOf("day")
    .toUTC()
    .toISO();
};

export const getTimeZoneFullName = (tz) => {
  const tzMap = {
    UTC: "UTC (Coordinated Universal Time)",
    PT: "Pacific Time (PT) - America/Los_Angeles",
    MT: "Mountain Time (MT) - America/Denver",
    CT: "Central Time (CT) - America/Chicago",
    ET: "Eastern Time (ET) - America/New_York",
    AKT: "Alaska Time (AKT) - America/Anchorage",
    HST: "Hawaii Time (HST) - Pacific/Honolulu",
  };
  return tzMap[tz] || tz;
};